/*
 * @Author: WeijianXu weijian.xu@unidt.com
 * @Date: 2024-04-30 15:24:34
 * @LastEditors: WeijianXu weijian.xu@unidt.com
 * @LastEditTime: 2024-06-13 11:58:32
 * @FilePath: \intelligent-knowledge-qa-pcd:\app\reps\ai-qa\assistant_portal_web\src\data\api-cuser.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from '@/core/request.js';

// 发送手机验证码
export function postPhoneVerifyCode(data) {
  return request({
    url: '/account-entity/sendMsg',
    method: 'post',
    data,
  });
}

// 发送用户验证码
export function sendUserMsg(data) {
  return request({
    url: '/account-entity/sendUserMsg',
    method: 'post',
    data,
  });
}

// 手机验证码登录、注册
export function postPhoneLogin(data) {
  return request({
    url: '/account-entity/loginByPhone',
    method: 'post',
    data,
  });
}

// 根据token查询用户信息
export function postUserInfo(data) {
  return request({
    url: '/account-entity/findCuserByToken', // '/account-entity/findByToken',
    method: 'post',
    data,
  });
}

// 获取用户历史对话
export function postHistoryQa(data) {
  return request({
    url: '/get_user_dialogue/',
    method: 'post',
    baseUrl: '/history_qa',
    data,
  });
}

// 对话反馈
export function talkFeedback(data) {
  return request({
    url: 'update_history_qa_feedback/',
    method: 'post',
    baseUrl: '/history_qa',
    data,
  });
}

// 场景配置详情
export function postQaConfigDetail(data) {
  return request({
    url: '/qaScenarioConfig/detail',
    method: 'post',
    data,
  });
}

/* 分享相关 */
// 根据分享码获取模型参数详情
export function getScenarioConfigDetail(shareCode) {
  return request({
    url: `/qaScenarioConfig/detailByShareCode/${shareCode}`,
    method: 'get',
  });
}
